import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import {
  TrendingUp as TrendingUpIcon,
  Receipt as ReceiptIcon,
  People as PeopleIcon,
  Payment as PaymentIcon,
  WarningAmber as WarningAmberIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  Store as StoreIcon,
  ShowChart as ShowChartIcon,
  Groups as GroupsIcon,
} from '@mui/icons-material';
import SummaryCard from './SummaryCard';
import { DASHBOARD_COLORS } from './dashboardStyles';

export const OVERVIEW_CARD_THEMES = {
  bills: { color: '#7c3aed', icon: ReceiptIcon },
  sales: { color: '#059669', icon: TrendingUpIcon },
  customers: { color: '#2563eb', icon: PeopleIcon },
  pending: { color: '#e11d48', icon: PaymentIcon },
  lowStock: { color: '#d97706', icon: WarningAmberIcon },
  expenses: { color: '#0d9488', icon: AccountBalanceWalletIcon },
  suppliers: { color: '#6366f1', icon: StoreIcon },
  profit: { color: '#2563eb', icon: ShowChartIcon },
  creditCustomers: { color: '#7c3aed', icon: GroupsIcon },
};

const TodayOverview = ({ title = 'Overview', cards, loading }) => (
  <Box sx={{ mb: 2 }}>
    <Typography
      variant="subtitle1"
      sx={{ fontWeight: 700, color: DASHBOARD_COLORS.text, mb: 1.5, fontSize: '1.05rem' }}
    >
      {title}
    </Typography>
    <Grid container spacing={1.5}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} md={4} lg={2} key={card.id}>
          <SummaryCard
            label={card.label}
            value={card.value}
            accentColor={card.accentColor}
            icon={card.icon}
            trend={card.trend}
            loading={loading}
            onClick={card.onClick}
            showAiAssistant={card.showAiAssistant}
            onAiAssistantClick={card.onAiAssistantClick}
          />
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default TodayOverview;
